import { Grid } from "@mui/material";
import { FC } from "react";
import background from "../../image/back-5_2.png";
import { teams } from "../../screen/NazoClusterQuizScreen";
import { TeamViewer } from "../common/TeamViewer";
import { StagePlayerProps } from "../NazoClusterQuizPlayer";

export const RegisterPlayer: FC<StagePlayerProps> = (props) => {
  return (
    <div
      style={{
        backgroundImage: `url(${background})`,
        backgroundSize: "contain",
        height: "100dvh",
      }}
    >
      <Grid container>
        {teams.map((team, i) => (
          <Grid item xs={12} key={i}>
            <TeamViewer
              teamName={team.teamName}
              teamColor={team.teamColor}
              teamId={i + 1}
              {...props}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};
